import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Form, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import ToggleListItem from '@components/ToggleListItem'

import type { UseDownloadMediaPayload } from '@modals/DownloadMediaModal/hooks/useDownloadMedia'

import Preset from '../Preset'

interface PresetImageSizesProps {
  downloadMediaPayload: UseDownloadMediaPayload,
  isPublicPage?: boolean,
}

const PresetImageSizes = (props: PresetImageSizesProps) => {
  const { downloadMediaPayload, isPublicPage } = props

  const {
    agencyWatermarkOnDownloadEnabled,
    callbacks: {
      buildAgencyPresets, resetSelectedPreset, setState, updateAgency,
    },
    currentUser,
    presets,
    selectedPreset,
    showCustomSizeForm,
    watermarkImagesEnabled,
  } = downloadMediaPayload

  const createCustomSizesText = currentUser.id ? 'Your available sizes are below, or you can create a custom size.' : ''

  return (
    <>
      <SidebarNoticeBox>
        <SidebarNoticeBox.Title>Select a Size</SidebarNoticeBox.Title>

        <SidebarNoticeBox.Paragraph>
          {`Please choose a size to export your selected media at. ${createCustomSizesText}`}
        </SidebarNoticeBox.Paragraph>
      </SidebarNoticeBox>

      <Box flexDirection="column" paddingX="large" variant="white">
        {presets.map(preset => (
          <Preset
            callbacks={{
              buildAgencyPresets,
              resetSelectedPreset,
              selectPreset: () => setState({ selectedPreset: preset }),
              updateAgency,
            }}
            // @ts-expect-error TS2322
            currentUser={currentUser}
            isPublicPage={isPublicPage}
            isSelected={selectedPreset.type === preset.type}
            key={preset.key}
            preset={preset}
          />
        ))}
      </Box>

      {agencyWatermarkOnDownloadEnabled && (
        <Box flexDirection="column" paddingX="large" marginTop="large">
          <ToggleListItem
            toggleValue={watermarkImagesEnabled}
            toggleOnText="On"
            toggleOffText="Off"
            toggleOnColor="green"
            toggleOffColor="red"
            onClick={() => setState({ watermarkImagesEnabled: !watermarkImagesEnabled })}
          >
            <>
              <ToggleListItem.Title>Watermark</ToggleListItem.Title>
              <ToggleListItem.Description>Show watermarks on images.</ToggleListItem.Description>
            </>
          </ToggleListItem>
        </Box>
      )}

      {!showCustomSizeForm && !isPublicPage && (
        <Form.Field label="More Options" marginTop="large">
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faCirclePlus} />}
            onClick={() => setState({ showCustomSizeForm: true })}
            size="medium"
          >
            Add Custom Size
          </Button>
        </Form.Field>
      )}
    </>
  )
}

export default PresetImageSizes
